<template>
<div class="k-page-content">
        <el-tabs v-model="activeName" class="box-eltab">
            <el-tab-pane label="流程步骤" name="first">
                <div class="k-page-common">
                    <div class="k-common-header">
                        <div class="k-filter-option k-filter-input" style="margin-bottom:0;">
                            <el-form :inline="true" :model="searchForm" size="mini" ref="searchForm">
                                <el-form-item label="平台名称">
                                    <el-input v-model="searchForm.menu_name" placeholder="请填写菜单名称" clearable></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" icon="el-icon-search" @click="doSearch">查询</el-button>
                                    <el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div class="k-common-con">
                        <div class="k-table-wrapper">
                            <div class="k-table-toolbar" style="margin-top:0;">
                                <div>
                                    <el-button type="primary" size="mini" @click="addMenusOpen">添加菜单</el-button>
                                </div>
                            </div>
                            <div class="k-table-con">
                                <el-table
                                    :data="tableData.data"
                                    style="width: 100%"
                                    row-key="id"
                                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                                    border
                                    stripe
                                    ref = "table"
                                    highlight-current-row
                                    @sort-change="sortChange"
                                    :height="tableHeight">
                                <el-table-column
                                        fixed
                                        prop="menu_name"
                                        label="菜单名称"
                                        min-width="200">
                                </el-table-column>
                                <el-table-column
                                        prop="menu_level"
                                        label="菜单层级"
                                        width="100">
                                </el-table-column>
                                <el-table-column
                                        prop="menu_sort"
                                        label="排序"
                                        width="100">
                                </el-table-column>
                                <el-table-column
                                        prop="menu_url"
                                        label="菜单访问地址"
                                        min-width="150">
                                </el-table-column>
								<el-table-column
								        prop="url_name"
								        label="地址名称"
								        min-width="100">
								</el-table-column>
                                <el-table-column
                                        prop="menu_icon"
                                        label="图标"
                                        width="150">
                                </el-table-column>
                                <el-table-column
                                        prop="create_time"
                                        label="创建时间"
                                        width="200"
                                        sortable="custom">
                                </el-table-column>
                                <el-table-column
                                        prop="update_time"
                                        label="修改时间"
                                        width="200"
                                        sortable="custom">
                                </el-table-column>
                                <el-table-column
                                        prop="is_show"
                                        label="是否显示"
                                        width="100">
										<template slot-scope="scope">
										  <el-tag :size="size" v-if="scope.row.is_show == 'YES'" type="success">显示</el-tag>
										  <el-tag :size="size" v-if="scope.row.is_show == 'NO'" type="danger">隐藏</el-tag>
										</template>
                                </el-table-column>
                                <el-table-column
                                        fixed="right"
                                        label="操作"
                                        min-width="150">
                                    <template slot-scope="scope">
                                        <el-button @click="handleTableEditOpen(scope.row)" type="text" :size="size">编辑</el-button>
                                        <el-button v-if="scope.row.is_show == 'NO'" @click="handleTableChangeShow(scope.row)" type="text" :size="size">显示</el-button>
                                        <el-button v-else @click="handleTableChangeShow(scope.row)" type="text" :size="size">隐藏</el-button>
                                        <el-button @click="handleTableDelete(scope.row)" type="text" :size="size" class="c-danger">
                                            删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
							<el-pagination
								background
								ref="pagination"
								@current-change="handleCurrentChange"
								:current-page="tableData.page | number"
								:page-size="tableData.pagesize | number"
								layout="total, prev, pager, next"
								:total="tableData.total | number">
							</el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    
    <el-drawer
        custom-class="k-drawer"
        :visible.sync="addFormVisiable"
        direction="rtl"
        size="40%">
        <el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="110px">
            <div class="drawer-header">
                <div class="header-title">
                    <span>添加菜单</span>
                    <i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
                </div>
            </div>
            <div class="drawer-content">
				<el-form-item label="菜单名称" prop="menu_name">
					<el-input v-model="addForm.menu_name" placeholder="请填写菜单名称" clearable></el-input>
				</el-form-item>

				<el-form-item label="排序" prop="menu_sort">
					<el-input v-model.number="addForm.menu_sort" placeholder="请填写菜单排序" clearable></el-input>
				</el-form-item>

				<el-form-item label="菜单图标" prop="menu_icon">
					<el-input v-model="addForm.menu_icon" placeholder="请填写菜单图标" clearable></el-input>
				</el-form-item>
				
				<el-form-item label="上级菜单" prop="menu_parent_path">
					<el-cascader
						v-model="addForm.menu_parent_path"
						:options="options.menus_options"
						:props="{ checkStrictly: true, label:'menu_name', value:'id' }"
						clearable></el-cascader>
				</el-form-item>
				
				<el-form-item label="菜单地址" prop="menu_url" v-if="addForm.menu_parent_path">
					<el-input v-model.number="addForm.menu_url" placeholder="请填写菜单地址" clearable></el-input>
				</el-form-item>
				
				<el-form-item label="菜单地址名称" prop="url_name" v-if="addForm.menu_parent_path">
					<el-input v-model="addForm.url_name" placeholder="请填写菜单地址名称" clearable></el-input>
				</el-form-item>
				
				<el-form-item label="菜单文件路径" prop="menu_dir" v-if="addForm.menu_parent_path">
					<el-input v-model="addForm.menu_dir" placeholder="请填写菜单文件路径" clearable></el-input>
				</el-form-item>

				<el-form-item label="是否显示" prop="is_show">
					<el-radio-group v-model="addForm.is_show">
						<el-radio label="YES">显示</el-radio>
						<el-radio label="NO">隐藏</el-radio>
					</el-radio-group>
				</el-form-item>
            </div>
            <div class="drawer-footer">
                <el-button type="primary" @click="addMenus" :size='size'>提交</el-button>
                <el-button :size='size' @click="addFormVisiable = false">取消</el-button>
            </div>
        </el-form>
    </el-drawer>
    
    <el-drawer
        custom-class="k-drawer"
        :visible.sync="editFormVisiable"
        direction="rtl"
        size="40%">
        <el-form :model="editForm" ref="editForm" :size="size" :rules="rules.editForm" label-width="110px">
            <div class="drawer-header">
                <div class="header-title">
                    <span>编辑菜单</span>
                    <i class="el-icon-close k-drawer-close" @click="editFormVisiable = false"></i>
                </div>
            </div>
            <div class="drawer-content">
                <el-form-item label="菜单名称" prop="menu_name">
                    <el-input v-model="editForm.menu_name" placeholder="请填写菜单名称" clearable></el-input>
                </el-form-item>
                
                <el-form-item label="排序" prop="menu_sort">
                    <el-input v-model.number="editForm.menu_sort" placeholder="请填写菜单排序" clearable></el-input>
                </el-form-item>
                
                <el-form-item label="菜单图标" prop="menu_icon">
                    <el-input v-model="editForm.menu_icon" placeholder="请填写菜单图标" clearable></el-input>
                </el-form-item>
                
                <el-form-item label="上级菜单" prop="menu_parent_path">
                	<el-cascader
                		v-model="editForm.menu_parent_path"
                		:options="options.menus_options"
                		:props="{ checkStrictly: true, label:'menu_name', value:'id' }"
                		clearable></el-cascader>
                </el-form-item>
                
                <el-form-item label="菜单地址" prop="menu_url" v-if="editForm.menu_parent_path.length > 0">
                    <el-input v-model.number="editForm.menu_url" placeholder="请填写菜单地址" clearable></el-input>
                </el-form-item>
                
                <el-form-item label="菜单地址名称" prop="url_name" v-if="editForm.menu_parent_path.length > 0">
                    <el-input v-model="editForm.url_name" placeholder="请填写菜单地址名称" clearable></el-input>
                </el-form-item>
                
                <el-form-item label="菜单文件路径" prop="menu_dir" v-if="editForm.menu_parent_path.length > 0">
                    <el-input v-model="editForm.menu_dir" placeholder="请填写菜单文件路径" clearable></el-input>
                </el-form-item>
                
                <el-form-item label="是否显示" prop="is_show">
                	<el-radio-group v-model="editForm.is_show">
                	    <el-radio label="YES">显示</el-radio>
                	    <el-radio label="NO">隐藏</el-radio>
                	</el-radio-group>
                </el-form-item>
            </div>
            <div class="drawer-footer">
                <el-button type="primary" @click="editUser" :size='size'>提交</el-button>
                <el-button :size='size' @click="editFormVisiable = false">取消</el-button>
            </div>
        </el-form>
    </el-drawer>
</div>
</template>
<script>
export default {
  props: ['info'],
  data() {
      return {
          addFormVisiable: false,
          editFormVisiable: false,
          checkSkVisiable: false,
          activeName: 'first',
          size:'mini',
          options: {
              menus_options: []
          },
          searchForm: {
              menu_name: '',
          },
          resetSearch: {
              menu_name: '',
          },
          addForm: {
              menu_name: '',
              menu_sort: '',
              menu_icon:'',
              is_show:'',
              menu_parent_path:'',
              menu_url:'',
              url_name:'',
			  menu_dir:''
          },
          editForm: {
              menu_name: '',
              menu_sort: '',
              menu_icon:'',
              is_show:'',
              menu_parent_path:'',
              menu_url:'',
              url_name:'',
              menu_dir:''
          },
          checkSkForm: {
              id: '',
              secret_key: ''
          },
          checkSk: {
              show: false,
              text: '显示',
          },
          rules: {
              addForm: {
                  'menu_name': [
                      {required: true, message: '请填写菜单名称', trigger: ['change', 'blur']},
                      {max: 50, message: '请填写正确的菜单名称，长度不超过 50', trigger: ['change', 'blur']}
                  ],
                  'menu_icon': [
                      {required: true, max: 50, message: '请填写正确的菜单图标，长度不超过 50', trigger: ['change', 'blur']}
                  ],
                  'menu_sort': [
                      {required: true, type: 'number', min: 0, message: '请填写正确的排序', trigger: ['change', 'blur']}
                  ],
                  'is_show': [
                      {required: true, message: '请选择菜单显示状态', trigger: ['change']}
                  ],
				  'menu_url': [
				      {required: true, message: '请填写菜单地址', trigger: ['change', 'blur']}
				  ],
				  'url_name': [
				      {required: true, message: '请填写地址名称', trigger: ['change', 'blur']},
				      {max: 50, message: '请填写正确的地址名称，长度不超过 50', trigger: ['change', 'blur']}
				  ],
				  'menu_dir': [
				      {required: true, message: '请填写菜单文件路径', trigger: ['change', 'blur']}
				  ]
              },
              editForm: {
                  'menu_name': [
                      {required: true, message: '请填写菜单名称', trigger: ['change', 'blur']},
                      {max: 50, message: '请填写正确的菜单名称，长度不超过 50', trigger: ['change', 'blur']}
                  ],
                  'menu_icon': [
                      {required: true, max: 50, message: '请填写正确的菜单图标，长度不超过 50', trigger: ['change', 'blur']}
                  ],
                  'menu_sort': [
                      {required: true, type: 'number', min: 0, message: '请填写正确的排序', trigger: ['change', 'blur']}
                  ],
                  'is_show': [
                      {required: true, message: '请选择菜单显示状态', trigger: ['change']}
                  ],
                  'menu_url': [
                      {required: true, message: '请填写菜单地址', trigger: ['change', 'blur']}
                  ],
                  'url_name': [
                      {required: true, message: '请填写地址名称', trigger: ['change', 'blur']},
                      {max: 50, message: '请填写正确的地址名称，长度不超过 50', trigger: ['change', 'blur']}
                  ],
                  'menu_dir': [
                      {required: true, message: '请填写菜单文件路径', trigger: ['change', 'blur']}
                  ]
              }
          },
          tableData: {
              total: 0,
              pagesize: 20,
              page: 1,
              data: []
          }
      }
  },
  computed: {
      tableHeight: function () {
          return window.innerHeight - 320;
      }
  },
  mounted: function () {
      this.handleSearch(this.searchForm);
  },
  methods: {
		//列表查询
		handleSearch(params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/fyauth/fyauth/menulist',param).then(res => {
			   if (res.code == 0) {
				   this.tableData = res.data;		
			   }else{
				   this.$message({
					   showClose: true,
					   message: res.msg,
					   type: 'warning'
				   });
			   }
			})
		},
		// 执行查询
		doSearch() {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset() {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange(e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
			  order = 'asc';
			} else if (e.order == 'descending') {
			  order = 'desc';
			} else {
			  prop = this.resetSearch.prop;
			  order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange(val) {
			this.handleSearch(this.searchForm, val);
		},
		// 添加菜单弹窗
		addMenusOpen(){
			this.addForm = {
              menu_name: '',
              menu_sort: '',
              menu_icon:'',
              is_show:'',
              menu_parent_path:'',
              menu_url:'',
              url_name:'',
			  menu_dir:''
          },
			this.getMenusOption()
			this.addFormVisiable = true;
		},
		// 添加菜单
		addMenus() {
		  this.$refs['addForm'].validate(function (valid) {
			  if (valid) {
				  this.loading = true;
				  this.$api.post('/admin/fyauth/fyauth/createmenus',this.addForm).then(res => {
					  if (res.code === 0) {
						  // 重新加载表格
						  this.handleSearch();
						  this.$message({
							  showClose: true,
							  message: '添加菜单成功！',
							  type: 'success'
						  });
						  this.addFormVisiable = false;
					  } else {
						  this.$message.error(res.msg);
					  }
					  this.loading = false
				  })
		
			  } else {
				  this.$message({
					  showClose: true,
					  message: '请填写正确的信息！',
					  type: 'warning'
				  });
			  }
		  }.bind(this));
		},
		//编辑弹窗
		handleTableEditOpen(row){
			this.$api.get('/admin/fyauth/fyauth/menuInfo',{id:row.id}).then(res => {
				  if (res.code == 0) {
					  this.editForm = res.data
					  this.getMenusOption(row.id)
					  this.editFormVisiable = true;
				  } else {
					  this.$message.error(res.msg);
				  }
				  this.loading = false
			})
		},
		//编辑
		editUser(){
			this.$refs['editForm'].validate(function (valid) {
			  if (valid) {
				  this.loading = true;
				  this.$api.put('/admin/fyauth/fyauth/editmenu',this.editForm).then(res => {
					  if (res.code === 0) {
						  // 重新加载表格
						  this.handleSearch();
						  this.$message({
							  showClose: true,
							  message: '菜单信息修改成功！',
							  type: 'success'
						  });
						  this.editFormVisiable = false;
					  } else {
						  this.$message.error(res.msg);
					  }
					  this.loading = false
				  })
			  } else {
				  this.$message({
					  showClose: true,
					  message: '请填写正确的信息！',
					  type: 'warning'
				  });
			  }
			}.bind(this));
		},
		//获取菜单下拉
		getMenusOption(id){
			this.$api.get('/admin/fyauth/fyauth/downList',{id:id ? id : ''}).then(res => {
				if (res.code === 0) {
				  this.options.menus_options = res.data;
				} else {
				  this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//删除
		handleTableDelete(row){
			this.$confirm('此操作将永久删除该菜单, 是否继续?', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
			}).then(function() {
			  this.loading = true;
			  this.$api.delete('/admin/fyauth/fyauth/deletemenu', {id:row.id}).then(res => {
				  if (res.code == 0) {
					  var data = this.tableData.data;
					  data.forEach(function (item, index) {
						  if (item.id == row.id) {
							  this.$delete(data, index);
						  } else if (item.children) {
							  item.children.forEach(function (value, key) {
								  if (value.id == row.id) {
									  this.$delete(item.children, key);
								  }
							  }.bind(this));
						  }
					  }.bind(this));
					  this.$message({
						  showClose: true,
						  message: '该菜单已成功删除！',
						  type: 'success'
					  });
				  } else {
					  this.$message.error(res.msg);
				  }
				  this.loading = false
			  })
			}.bind(this))
		},
		// 修改菜单显示状态
		handleTableChangeShow: function (row) {
		  this.$confirm('此操作将修改该菜单的显示状态, 是否继续?', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
		  }).then(function() {
			  this.loading = true;
			  this.$api.put('/admin/fyauth/fyauth/scMenu',{id:row.id}).then(res => {
				  if (res.code == 0) {
					  var data = this.tableData.data;
					  data.forEach(function (item, index) {
						  if (item.id == res.data.id) {
							  this.$set(data, index, res.data);
						  } else if (item.children) {
							  item.children.forEach(function (value, key) {
								  if (value.id == res.data.id) {
									  this.$set(item.children, key, res.data);
								  }
							  }.bind(this));
						  }
					  }.bind(this));
					
					  this.$message({
						  showClose: true,
						  message: '菜单信息修改成功！',
						  type: 'success'
					  });
				  } else {
					  this.$message.error(res.msg);
				  }
				  this.loading = false
			  })
		  }.bind(this))
		}
    }
}
</script>